import MosaicImage from './MosaicImage'

export default MosaicImage
